module.exports = __webpack_public_path__ + "img/p-15.c75332e0.webp";